// components/CartIcon.tsx
import React from "react";
import { useCart } from "./CartContext";
import { CiShoppingCart } from "react-icons/ci";

const CartIcon = () => {
  const { toggleDrawer, state } = useCart(); // Access cart and toggleDrawer
  return (
    <button
      onClick={toggleDrawer}
      style={{ position: "relative", cursor: "pointer" }}
    >
      <CiShoppingCart size={24} /> {/* Optional: Adjust the size */}
    </button>
  );
};

export default CartIcon;
